import { render } from "./temporaryRecord.vue?vue&type=template&id=a4da92da&scoped=true"
import script from "./temporaryRecord.vue?vue&type=script&lang=js"
export * from "./temporaryRecord.vue?vue&type=script&lang=js"

import "./temporaryRecord.vue?vue&type=style&index=0&id=a4da92da&lang=scss&scoped=true"

import exportComponent from "E:\\zhouwang\\work\\web_dev\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4da92da"]])

export default __exports__